// extracted by mini-css-extract-plugin
export default {"dialog__content":"ImpersonationIcon_dialog__content__N1hwY","person-search":"ImpersonationIcon_person-search__WNwpm"};